unit f_noteinserisci;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator, f_selezione, un_user;
type

  { TFrmNoteInserisci }

  TFrmNoteInserisci = class(TWidget)
    nuovorecord :String;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    procedure salva_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;

  private

  published
    procedure dscategoria_click; async;
    procedure dsemail_click; async;
    QrySeleziona: TQuery;
    QryNote: TQuery;
    dscategoria: TJSHTMLSelectElement;
    dstitolo: TJSHTMLSelectElement;
    dsnota: TJSHTMLSelectElement;
    pnlstato: TJSHTMLSelectElement;
    dtscadenza: TJSHTMLSelectElement;
    dsemail: TJSHTMLSelectElement;

  end;

implementation

{$R *.html}

{ TFrmNoteInserisci }

procedure TFrmNoteInserisci.AfterRender;
begin

 //

end;

procedure TFrmNoteInserisci.AfterDomAppend;
begin

//

end;

procedure TFrmNoteInserisci.salva_click(Event: TJSEvent);
var
  NuovoID: Integer;
begin
  // 1. Validazione Campi
  if Trim(dstitolo.value) = '' then
  begin
    ShowMessage('Il titolo è obbligatorio');
    Exit;
  end;

  try
    // 2. Risoluzione errore "Query già in apertura"
    // Chiudiamo forzatamente la query se è rimasta appesa da chiamate precedenti
    if QryNote.Active then
      QryNote.Close;

    // 3. Apertura struttura (veloce)
    QryNote.SQL.Text := 'SELECT IDNOTA, IDSOCIETA, DTDATA, DTSCADENZA, DSCATEGORIA, '
                        + ' DSTITOLO, DSNOTA, DSEMAIL, FLSTATO, IDUTENTE '
                        + ' FROM NO_NOTE WHERE 1=0 ';
    await(QryNote.Open);

    // 4. Recupero ID
    NuovoID := await(GetNextId('NO_NOTE'));

    // 5. Inserimento dati
    QryNote.Append;
    QryNote.FieldByName('IDNOTA').AsInteger     := NuovoID;
    QryNote.FieldByName('IDSOCIETA').AsString   := 'DON001';

    // AGGIUNTO: Inseriamo la data odierna (spesso causa del 500 se vuota)
    QryNote.FieldByName('DTDATA').AsDateTime    := Now;
    QryNote.FieldByName('DTSCADENZA').AsDateTime :=
    EncodeDate(StrToInt(Copy(dtscadenza.value, 1, 4)), StrToInt(Copy(dtscadenza.value, 6, 2)),
    StrToInt(Copy(dtscadenza.value, 9, 2)));
    QryNote.FieldByName('DSCATEGORIA').AsString := dscategoria.value;
    QryNote.FieldByName('DSTITOLO').AsString    := dstitolo.value;
    QryNote.FieldByName('DSNOTA').AsString      := dsnota.value;
    QryNote.FieldByName('DSEMAIL').AsString      := dsemail.value;
    QryNote.FieldByName('FLSTATO').AsString     := 'APERTA';

    // Controllo sicurezza su IDUTENTE
    if (user.QryUtenti.Active) and (not user.QryUtenti.IsEmpty) then
      QryNote.FieldByName('IDUTENTE').AsString := user.QryUtenti.FieldByName('idutente').AsString
    else
      QryNote.FieldByName('IDUTENTE').AsString := 'SISTEMA';

    QryNote.Post;

    // 6. Sincronizzazione reale col Database
    // Se qui ricevi ancora 500, controlla che DSTITOLO non superi i 250 caratteri
    await(QryNote.ApplyUpdates);

    ShowMessage('Nota salvata con successo (ID: ' + IntToStr(NuovoID) + ')');

    // Chiudiamo la form solo DOPO il successo dell'ApplyUpdates
    Close();

  except
    on E: Exception do
    begin
      // Qui leggerai l'errore specifico del database (es. string truncation o PK violation)
      ShowMessage('Errore Database: ' + E.Message);
    end;
  end;
end;

procedure TFrmNoteInserisci.chiudi_click(Event: TJSEvent);
begin

  Close;

end;

procedure TFrmNoteInserisci.dscategoria_click;
begin
  
  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;

      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= 'select dscategoria as categoria '
      + ' from no_categorie ';
      AWait(QrySeleziona.Open);

    end;

    if AWait(Show) = mrOK then
    begin
      dscategoria.value := QrySeleziona.FieldByName('categoria').AsString;
    end;
  end;

end;

procedure TFrmNoteInserisci.dsemail_click;
var
  FrmSel: TFrmSelezione;
begin
 // Creiamo l'istanza della form di selezione
  FrmSel := TFrmSelezione.Create;

  // Definiamo cosa deve fare la query all'interno della form di selezione
  FrmSel.OpenQrySeleziona := procedure async
  begin
    FrmSel.CloseForm := True;

    FrmSel.QrySeleziona.Close;
    // Prendiamo l'email dall'anagrafica
    FrmSel.QrySeleziona.SQL.Text := 'select dsragionesociale as utente, dsemail as email from an_anagrafiche';

    await(FrmSel.QrySeleziona.Open);
  end;

  // Mostriamo la form e attendiamo il risultato (OK o Annulla)
  if await(FrmSel.Show) = mrOK then
  begin
    // Assegniamo il valore selezionato al campo dsemail della form principale
    // Nota: dsemail deve essere l'ID corretto nell'HTML
    dsemail.value := FrmSel.QrySeleziona.FieldByName('email').AsString;
  end;
end;

initialization
  RegisterWeb(TFrmNoteInserisci);

end.

